var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',{staticClass:"lag-display__title",attrs:{"xs12":""}},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]),_c('v-flex',{class:{
      'lag-display__lag': true,
      'no-lag': _vm.lag < 100,
      'small-lag': _vm.lag >= 100 && _vm.lag < 500,
      'medium-lag': _vm.lag >= 500 && _vm.lag < 1000,
      'large-lag': _vm.lag >= 1000
    },attrs:{"xs12":""}},[_vm._v("\n    "+_vm._s(_vm.lag)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }